import Button from "components/common/buttons/buttons";
import { useState } from "react";

function DiscussSubscribeButton({
  text = "구독하기",
  isSubscribe = false,
  debateAlarmRegister,
  size = "md",
  from = "header",
}: {
  text: string;
  isSubscribe: boolean;
  debateAlarmRegister: any;
  size?: "md" | "sm";
  from?: "agenda" | "header";
}) {
  return (
    <div>
      <Button
        type={isSubscribe ? "tertiary" : "secondary"}
        text={isSubscribe ? "구독 중" : text}
        size={size}
        clickHandler={() => {
          if (isSubscribe) return;
          debateAlarmRegister(false, "NEW");
        }}
        data-gtm-id={`report-${from}-subscribe-button`}
      />
    </div>
  );
}

export default DiscussSubscribeButton;
